<!--官方号-->
<template>
  <div class="official-container">
    <div class="official-content">
      <el-row :gatter="16">
        <el-col :span="17">
          <!--关注收藏的文章、动态、视屏-->
          <div class="official-article">
            <div class="info-list" v-for="article of officialInfo.article_list" @click="details(article)"
                 v-if="article.type!=3">
              <div v-if="article.photo.length<1">
                <p class="span-bold">{{ article.title ? article.title : article.keyword }}</p>
                <p>
                  <span v-if="article.is_top==1" class="span-red">置顶</span>
                  <span class="span-default">{{ article.user_name }}</span>
                  <span class="span-default">{{ article.time }}</span>
                </p>
              </div>
              <div v-else-if="article.photo.length<3">
                <el-row>
                  <el-col :span="5">
                    <el-image :src="article.photo[0]" style="height: 110px;width: 100%" fit="cover"></el-image>
                    <i class="iconfont icon-bofang" v-if="article.type==2"></i>
                  </el-col>
                  <el-col :span="19" style="padding-left: 10px;">
                    <p class="p-bold">{{ article.title ? article.title : article.keyword }}</p>
                    <p>
                      <span v-if="article.is_top==1" class="span-red">置顶</span>
                      <span class="span-default">{{ article.user_name }}</span>
                      <span class="span-default">{{ article.time }}</span>
                    </p>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <p class="span-bold">{{ article.title ? article.title : article.keyword }}</p>
                <el-row>
                  <el-col :span="5" v-for="(photo,index) of article.photo" v-if="index<3" class="imgs">
                    <el-image :src="photo" style="height: 110px;width: 100%" fit="cover"></el-image>
                  </el-col>
                </el-row>
                <p>
                  <span v-if="article.is_top==1" class="span-red">置顶</span>
                  <span class="span-default">{{ article.user_name }}</span>
                  <span class="span-default">{{ article.time }}</span>
                </p>
              </div>
            </div>
            <!-- 分页 -->
            <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
          </div>
        </el-col>
        <el-col :span="7">
          <!--关注的店铺用户-->
          <div class="official-user">
            <div class="clearfix">
              <span style="font-size: 18px;font-family: 'SourceHanSansCN';color: #333333;border-left: 3px solid #1637FF;padding-left: 10px;">推荐官方号</span>
            </div>
            <template v-for="(follow,index) of officialInfo.follow" v-if="index<3">
              <div @click="authorPage(follow)" class="official-user-list">
                <div class="official-logo">
                  <el-image class="official-img" :src="follow.user_avatar" fit="contain"/>
                  <i class="official-icon">官</i>
                </div>
                <div class="official-right">
                  <p class="user-name">{{ follow.user_name }}</p>
                  <p class="type-name">{{ follow.identity_type_name }}</p>
                </div>
              </div>
            </template>
            <div style="text-align: center;">
              <el-button type="primary" plain @click="officialNumberAll">查看更多</el-button>
            </div>
          </div>
          <open-cloud v-if="CustomInfo.status!=1"/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import page from "@/components/page/pages";
import {officialNumberArticleList} from '@/api/interfaceApi'
import OpenCloud from "@/components/children/openCloud";
export default {
  name: "officialNo",
  components: {OpenCloud, page},
  data() {
    return {
      cid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      officialInfo: {},
      maxIndex: 6,
      show_more: false,
      min_height: document.documentElement.clientHeight - 723,
      CustomInfo:{},
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '2'
      }
    },
    activeTabs: {
      type: Object,
      default() {
        return {
          epidemic_url: "",
          image: "",
          is_epidemic: 0,
          is_local: 0,
          name: "推荐",
          nid: '2',
          no: 0,
        };
      }
    },
    cityList: {
      type: Object,
      default() {
        return {
          id: 500000,
          lat: 29.533155,
          level: 1,
          lng: 106.504959,
          name: "重庆",
          pid: 0,
          short_name: "重庆"
        }
      }
    }
  },
  watch: {
    activeIndex: function (val, oldVal) {
      this.tablePage.currentPage = 1;
      this.getInfo();
    }
  },
  methods: {
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInfo();
    },
    /*获取列表数据*/
    getInfo() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      officialNumberArticleList({
        page: this.tablePage.currentPage,
        uid: cid != 0 && cid != undefined ? cid : 0,
        pageLimit: this.tablePage.pageSize,
      }).then(res => {
        if (res.code == 200) {
          window.scrollTo(0, 0);
          this.officialInfo = res.content;
          this.tablePage.total = res.content.article_list.length;
        }
      })
    },
    /*显示隐藏更多关注店铺用户*/
    moreOfficial(status) {
      if (status) {
        this.maxIndex = 6;
        this.show_more = false;
      } else {
        this.maxIndex = this.officialInfo.follow.length;
        this.show_more = true;
      }
    },
    /*查看关注店铺信息*/
    authorPage(row) {
      let routeData = this.$router.resolve({
        name: "officialNumberDetails",
        path: '/officialCloud/officialNumberDetails',
        query:{
          id:row.bid
        }
      });
      window.open(routeData.href, '_blank')
    },
    /*查看详情*/
    details(row) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: row.id,
            type: row.type,
          },
          params: {cid: this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    /*查看全部官方号*/
    officialNumberAll(){
      let routeData = this.$router.resolve({
        name: "officialNumberAll",
        path: '/officialCloud/officialNumberAll',
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')).cid : 0;
    this.CustomInfo = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')) : {};
  }
}
</script>
<style scoped>
.official-container >>> .el-button--primary.is-plain {
  color: #1637FF;
  background: #ffffff;
  border-color: #1637FF;
  width: 70%;
  padding: 15px;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.official-container {
  .official-article {
    .info-list {
      padding: 15px 0px;
      .span-bold {
        font-size: 20px;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
      }
      .p-bold {
        font-size: 18px;
        font-weight: 100;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
        min-height: 80px;
      }
      .imgs {
        margin-right: 10px;
        margin-top: 10px;
      }
      p {
        font-size: 16px;
        margin-block-start: 10px;
        margin-block-end: 10px;
        .span-red {
          color: #FE273B;
          font-size: 14px;
          padding-right: 20px;
          font-weight: 100;
          font-family: 'SourceHanSansCN';
        }
        .span-default {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          padding-right: 20px;
        }
      }

      .icon-bofang {
        font-size: 30px;
        color: white;
        margin-top: 4.5%;
        position: absolute;
        margin-left: -12.2%;
      }
    }
  }
  .official-user {
    padding-bottom: 40px;
    .clearfix{
      padding: 30px 0px;
    }
    .official-user-list {
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 30px;
      .official-logo {
        .official-icon {
          position: absolute;
          font-size: 12px;
          background: #1637FF;
          color: #ffffff;
          font-style: normal;
          padding: 2px 5px;
          border-radius: 50%;
          margin-top: 40px;
          margin-left: -15px;
        }
        .official-img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 1px solid #d1d1d1;
        }
      }
      .official-right {
        padding: 10px 0px 10px 15px;
        p {
          margin-block-end: 0px;
          margin-block-start: 0px;
        }
        .user-name {
          font-size: 14px;
          color: #333333;
          font-family: 'SourceHanSansCN';
        }
        .type-name {
          font-size: 14px;
          color: #999999;
          font-family: 'SourceHanSansCN';
        }
      }
    }
    .official-user-list:last-child{
      margin-bottom: 0px;
    }
  }
}
</style>